module.exports = __webpack_public_path__ + "img/logo_oncogitiel_white_new.09850cd9.png";